// AboutUsPage.jsx
import React from 'react';
import { Box, Container, Typography, Grid, Card, CardContent, Avatar, Button } from '@mui/material';
import { Link } from 'react-router-dom';

const teamMembers = [
  { name: 'Dr. Ana Pérez', role: 'Chief Medical Officer', avatarUrl: '/images/team1.jpg' },
  { name: 'Ing. Carlos Ruiz', role: 'Lead Developer', avatarUrl: '/images/team2.jpg' },
  { name: 'Lic. María Gómez', role: 'Operations Manager', avatarUrl: '/images/team3.jpg' },
];

const values = [
  { title: 'Honestidad   ', description: 'We treat every patient with empathy and respect.' },
  { title: 'Responsabilidad', description: 'Our actions are guided by honesty and ethics.' },
  { title: 'Integridad', description: 'We leverage technology to improve patient care.' },
  { title: 'Empatía', description: 'We leverage technology to improve patient care.'}
];

const AboutUs = () => {
  return (
    <Box component="main">
      {/* Hero Section */}
      <Box
        sx={{
          py: 20,
          textAlign: 'center',
          color: 'black',
          background: 'url(/images/hero-about.jpg) center/cover no-repeat',
        }}
      >
        <Container maxWidth="md">
          <Typography variant="h3" component="h1" gutterBottom>
            Sobre Nosotros
          </Typography>
          <Typography variant="h6">
            Cardex Médico representa la evolución digital del tradicional kárdex de enfermería o ficha clínica. Su objetivo principal es digitalizar,
centralizar y organizar la información vital de los pacientes, haciéndola accesible de forma segura y en tiempo real para los
profesionales de la salud.
          </Typography>
        </Container>
      </Box>

      {/* Mission & Vision */}
      <Container sx={{ py: 8 }}>
        <Grid container spacing={4}>
          <Grid item xs={12} md={6}>
            <Typography variant="h4" gutterBottom>Nuestra Misión</Typography>
            <Typography variant="body1">
              Tener disponibilidad información vital para salvaguardar la integridad de las personas en situaciones de urgencia médica.
            </Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography variant="h4" gutterBottom>Nuestra Visión</Typography>
            <Typography variant="body1">
              Crear conciencia de la importancia de tener disponible nuestra información médica para ser atendidos en forma adecuada.
            </Typography>
          </Grid>
        </Grid>
      </Container>

      {/* Our Team 
      <Container sx={{ py: 8 } }>
        <Typography variant="h4" align="center" gutterBottom>Conoce a Nuestro Equipo</Typography>
        <Grid container spacing={4}>
          {teamMembers.map((member) => (
            <Grid item key={member.name} xs={12} sm={6} md={4}>
              <Card sx={{ textAlign: 'center', p: 2 }}>
                <Avatar
                  alt={member.name}
                  src={member.avatarUrl}
                  sx={{ width: 100, height: 100, mx: 'auto', mb: 2 }}
                />
                <CardContent>
                  <Typography variant="h6">{member.name}</Typography>
                  <Typography variant="subtitle2" color="text.secondary">
                    {member.role}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>*/}

      {/* Values Section */}
      <Box sx={{ backgroundColor: 'grey.100', py: 8 }}>
        <Container>
          <Typography variant="h4" align="center" gutterBottom>Nuestros Valores</Typography>
          <Grid container spacing={4}>
            {values.map((val) => (
              <Grid item key={val.title} xs={12} md={4}>
                <Box sx={{ textAlign: 'center', p: 2 }}>
                  <Typography variant="h5" gutterBottom>{val.title}</Typography>
                  <Typography variant="body1" color="text.secondary">{val.description}</Typography>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>

      {/* CTA Section */}
      <Box sx={{ py: 8, textAlign: 'center' }}>
        <Container>
          <Typography variant="h4" gutterBottom>¿Listo para trabajar con nosotros?</Typography>
          <Typography variant="body1" sx={{ mb: 4 }}>
            Ponte en contacto para explorar cómo podemos mejorar juntos la atención médica.
          </Typography>
            <Button
                component={Link}
                to="/contact-us"
                variant="contained"
                size="large"
                color="primary"
            >
            Contáctanos
            </Button>
        </Container>
      </Box>
    </Box>
  );
};

export default AboutUs;
